import { render } from "./DisputeFilter.vue?vue&type=template&id=101a18a0&scoped=true"
import script from "./DisputeFilter.vue?vue&type=script&lang=js"
export * from "./DisputeFilter.vue?vue&type=script&lang=js"

import "./DisputeFilter.vue?vue&type=style&index=0&id=101a18a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101a18a0"]])

export default __exports__